import LocalizedStrings from "react-localization";
import LocalText from "src/local";

const localizationStrings = new LocalizedStrings({
  ja: {
    errorTile: LocalText.common.error,
    btnOk: LocalText.common.ok,
    btnCancel: LocalText.common.cancel,
    errorAmplifyAuthUserNotFoundException:
      LocalText.error.amplifyAuthUserNotFoundException,
    errorAmplifyAuthNotAuthorizedException:
      LocalText.error.amplifyAuthNotAuthorizedException,
    errorAmplifyAuthCodeMismatchException:
      LocalText.error.amplifyAuthCodeMismatchException,
    errorAmplifyAuthInvalidPasswordException:
      LocalText.error.amplifyAuthInvalidPasswordException,
    errorAmplifyAuthUsernameExistsException:
      LocalText.error.amplifyAuthUsernameExistsException,
  },
});

export { localizationStrings };
